import { DockSection } from './types'
import { RootState } from '../../../src/reducers'

export function openSectionSelector(state: RootState): DockSection | undefined {
  return state.dock.openSection
}

export function isDockSectionOpenSelector(section: DockSection) {
  return function isDockSectionOpenSelector(state: RootState) {
    return state.dock.openSection === section
  }
}
